import React from 'react';
import ImageGallery from 'react-image-gallery';

import "./photo-gallery.scss";

function PhotoGallery() {
    var imageTest = [
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-01-Large.jpg"),
            originalAlt: "Salty at Georgian Bay Park, Aug 20, 2022",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-01-Thumb.jpg"),
            description: "Salty at Georgian Bay Park, Aug 20, 2022",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-02-Large.jpg"),
            originalAlt: "\"I once caught a fish this big\"",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-02-Thumb.jpg"),
            description: "\"I once caught a fish this big\"",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-03-Large.jpg"),
            originalAlt: "Promo Shot",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-03-Thumb.jpg"),
            description: "Promo Shot",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-04-Large.jpg"),
            originalAlt: "Jono at practice",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-04-Thumb.jpg"),
            description: "Jono at practice",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-06-Large.jpg"),
            originalAlt: "Salty at practice",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-06-Thumb.jpg"),
            description: "Salty at practice",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-07-Large.jpg"),
            originalAlt: "Salty at practice",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-07-Thumb.jpg"),
            description: "Salty at practice",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-08-Large.jpg"),
            originalAlt: "We are all Salty",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-08-Thumb.jpg"),
            description: "We are all Salty",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-09-Large.jpg"),
            originalAlt: "Gav ready to give 'er on bass",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-09-Thumb.jpg"),
            description: "Gav ready to give 'er on bass",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-10-Large.jpg"),
            originalAlt: "Jono laying it down",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-10-Thumb.jpg"),
            description: "Jono laying it down",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-11-Large.jpg"),
            originalAlt: "Brian & axes",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-11-Thumb.jpg"),
            description: "Brian & axes",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-13-Large.jpg"),
            originalAlt: "Keys to the new band room - Summer 2023",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-13-Thumb.jpg"),
            description: "Keys to the new band room - Summer 2023",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-14-Large.jpg"),
            originalAlt: "New band room - Winter 2023",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-14-Thumb.jpg"),
            description: "New band room - Winter 2023",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-15-Large.jpg"),
            originalAlt: "Having a laugh",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-15-Thumb.jpg"),
            description: "Having a laugh",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-16-Large.jpg"),
            originalAlt: "Live @ Malones, one of our favorite venues",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-16-Thumb.jpg"),
            description: "Live @ Malones, one of our favorite venues",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-17-Large.jpg"),
            originalAlt: "Jono in the groove",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-17-Thumb.jpg"),
            description: "Jono in the groove",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-18-Large.jpg"),
            originalAlt: "Brian picking away",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-18-Thumb.jpg"),
            description: "Brian picking away",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-19-Large.jpg"),
            originalAlt: "Brian in rock and rampage mode",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-19-Thumb.jpg"),
            description: "Brian in rock and rampage mode",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-20-Large.jpg"),
            originalAlt: "A quick shot from practice",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-20-Thumb.jpg"),
            description: "A quick shot from practice",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-21-Large.jpg"),
            originalAlt: "Practice at Lynx Studios",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-21-Thumb.jpg"),
            description: "Practice at Lynx Studios",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-22-Large.jpg"),
            originalAlt: "Practice at Lynx Studios",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-22-Thumb.jpg"),
            description: "Practice at Lynx Studios",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-23-Large.jpg"),
            originalAlt: "Salty Live at the Lion and Unicorn",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-23-Thumb.jpg"),
            description: "Salty Live at the Lion and Unicorn",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-24-Large.jpg"),
            originalAlt: "#wesaltythree - magic tree",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-24-Thumb.jpg"),
            description: "#wesaltythree - magic tree",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-25-Large.jpg"),
            originalAlt: "#wesaltythree - magic tree #2",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-25-Thumb.jpg"),
            description: "#wesaltythree - magic tree #2",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-26-Large.jpg"),
            originalAlt: "#wesaltythree - magic tree #3",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-26-Thumb.jpg"),
            description: "#wesaltythree - magic tree #3",
        },
        {
            original: require("../../assets/images/photo-gallery/Salty-Promo-27-Large.jpg"),
            originalAlt: "Why so serious?!",
            thumbnail: require("../../assets/images/photo-gallery/Salty-Promo-27-Thumb.jpg"),
            description: "Why so serious?!",
        },
    ];

    return (
        <ImageGallery
            items={imageTest}
            showPlayButton={false}
            thumbnailPosition={"left"}
        />
    );
}

export default PhotoGallery;